import { HeadCellType } from "../../../utils/appConstants";

export const headCells: HeadCellType[] = [
  {
    id: "blank",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "",
    width: "1%",
  },
  {
    id: "Port",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Port",
    width: "30%",
  },
  {
    id: "provider_name",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    tooltipTitle: "If this resource is purchased, this is the provider of the service.",
    label: "Provider",
    width: "30%",
  },
  // {
  //   id: 'service_description',
  //   align: 'left',
  //   disablePadding: false,
  //   sortEnabled: false,
  //   tooltipTitle: 'Description of the Service from the MarketPlace',
  //   label: 'Service Description',
  //   width: '40%',
  // },
  {
    id: "action",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Status",
    width: "20%",
  },
  {
    id: "action2",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Marketplace",
    width: "20%",
  },
  {
    id: "on_wxchange",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "WaveXchange",
    width: "19%",
  },
];

export const headCellsList: HeadCellType[] = [
  {
    id: "port_description",
    align: "left",
    disablePadding: false,
    sortEnabled: true,
    label: "Port",
    width: "25%",
  },
  {
    id: "ne_name",
    align: "left",
    disablePadding: false,
    sortEnabled: true,
    label: "Node",
    width: "20%",
  },
  {
    id: "organization_name",
    align: "left",
    disablePadding: false,
    sortEnabled: true,
    tooltipTitle: "If this resource is purchased, this is the provider of the service.",
    label: "Provider",
    width: "25%",
  },
  {
    id: "action",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Status",
    width: "15%",
  },
  {
    id: "action2",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "Marketplace",
    width: "15%",
  },
  {
    id: "on_wxchange",
    align: "left",
    disablePadding: false,
    sortEnabled: false,
    label: "WaveXchange",
    width: "15%",
  },
];
